export enum SignCopyType {
  NewDocument = 'newDocument',
  WithMetadata = 'withMetadata',
  NewVersion = 'newVersion',
}
